import types from 'constants/actionTypes';
import { setCurrentUser } from 'utils/localStorage';
 
const initialState = {
  remainingQuota: 0,
  totalQuota: 0,
  inCart: 0,
  productionPeriod: '',
  closingTime: null,
  brand: null,
  productType: null,
};
 
const dashboard = (state, { type, payload }) => {
  if (typeof state === 'undefined') {
    return initialState;
  }
 
  switch (type) {
    case types.GET_DASHBOARD_REQUEST_SUCCESS: {
      const result = payload?.result;
      if (result) {
        setCurrentUser({
          userId: result.userId,
          displayName: result.dealerName,
        });
        return { ...state, ...result };
      } else {
        sessionStorage.setItem('No result in payload for GET_DASHBOARD_REQUEST_SUCCESS', payload);
        return state; // or optionally return initialState
      }
    }
 
    case types.GET_DASHBOARD_REQUEST_FAILURE:
    default:
      return state;
  }
};
 
export default dashboard;
